<!-- <div *ngIf="objectTables"> -->
<app-navbar class="lighter"></app-navbar>
<app-object-header [objectContext]="headerSectionContext" [objectContextDetails]="headerDetailsSectionContext"
  [uuid]="uuid" [mainImage]="mainImage" class="lighter"></app-object-header>
<app-object-media [uuid]="uuid" class="lighter"></app-object-media>
<app-object-links *ngIf="linksSectionContext && linksSectionContext.columns[0].data.length > 0" [linksContext]="linksSectionContext"
  class="lightest"></app-object-links>
<!-- <app-object-relatives class="dark"></app-object-relatives> -->
<app-object-location [location]="locationCoordinates" [locationContext]="locationSectionContext"
  class="light"></app-object-location>
<app-contacts class="light"></app-contacts>
<app-footer class="lightest"></app-footer>
<!-- </div> -->

<!-- <div *ngIf="!objectTables">
  Object not found
</div> -->